import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface EmployeeField {
  field: string,
  invalid: boolean
}

interface EmployeeFieldsState {
  employeeFields: EmployeeField[];
  setEmployeeFields: (newEmployeeFields: EmployeeField[] | undefined) => void;
}

export const useEmployeeFieldsStore = create<EmployeeFieldsState>()(
  devtools(
    (set) => ({
      employeeFields: [],
      setEmployeeFields: (newEmployeeFields) =>
        set(() => ({
          employeeFields: newEmployeeFields ? [...newEmployeeFields] : [],
        })),
    }),
    { name: "EmployeeFieldsStore" }
  )
);
